import { render, staticRenderFns } from "./ShopOrdDetails.vue?vue&type=template&id=99139aae&scoped=true&"
import script from "./ShopOrdDetails.vue?vue&type=script&lang=js&"
export * from "./ShopOrdDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShopOrdDetails.vue?vue&type=style&index=0&id=99139aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99139aae",
  null
  
)

export default component.exports